import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const BillingPaymentTrack = (props) => {
	return (
		<SvgIcon {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0z"
				fill="#fff"
			/>
		</SvgIcon>
	);
};

export default BillingPaymentTrack;
